import React from "react";

import { CookieBanner } from "src/widgets/CookieBanner/ui/CookieBanner";

export const ModalWidgets: React.FC = () => {
  return (
    <>
      <CookieBanner />
    </>
  );
};
